import { render, staticRenderFns } from "./ResourceCard.vue?vue&type=template&id=60a528bf"
import script from "./ResourceCard.vue?vue&type=script&lang=ts"
export * from "./ResourceCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports